// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "-legacy." + {"31":"55dc19eb","157":"5237c955","250":"2907cc50","300":"e7b4fa76","520":"9a7b2c0e","521":"865fd6b1","525":"a93233f3","701":"dad011d7","758":"1bbd082a"}[chunkId] + ".js";
};